import { type QueryOptions } from '@tanstack/query-core'

import { type DcEntity } from '@/libs/api'
import { type DcsListRequestQuery, type UserRole } from '@/libs/api/types'

import { fetchDcs } from '../api'
import { dcsQueryKeys } from '../query-keys'

/**
 * 利用可能拠点一覧のQueryOptionsを返す
 */
export const getAvailableDcsSelectQueryOptions = (
  tenantKey: string,
  user: { id: number; userRole: UserRole }
): Required<Pick<QueryOptions<DcEntity[]>, 'queryKey' | 'queryFn'>> => {
  const query: DcsListRequestQuery = {
    userId: user.id,
    orders: ['code.asc']
  }
  return {
    queryKey: dcsQueryKeys.select(tenantKey, query),
    queryFn: async ({ signal }) => {
      const { data } = await fetchDcs(
        {
          tenantKey,
          query
        },
        signal
      )
      return data
    }
  }
}
